import * as React from 'react'
import { DashboardLayoutConnected } from './DashboardLayoutConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const DashboardLayoutExamples = () => {
  return (
    <div className="DashboardLayoutExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <DashboardLayoutConnected />
      </Provider>
    </div>
  )
}
